import React, { useState } from "react";
import {
  TextInput,
  Button,
  Group,
  SimpleGrid,
  Modal,
  Select,
  FileInput,
  PasswordInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { apiWithInterceptor } from "../../../../api";

const CreateUserModal = ({ opened, setOpenModal }) => {
  const form = useForm({
    initialValues: {
      email: "",
      username: "",
      password: "",
      profile_image: null,
      privileges: "",
    },

    validate: {
      email: (values) => (/^\S+@\S+$/.test(values) ? null : "Invalid email"),
      username: (values) =>
        values.length < 2 ? "Name must have at least 2 letters" : null,
      password: (values) =>
        values.length < 5 ? "Password must have at least 2 character" : null,
    },
  });

  return (
    <>
      <Group position="center">
        <Modal
          title="New user"
          opened={opened}
          onClose={() => setOpenModal(false)}
        >
          <SimpleGrid verticalSpacing="lg">
            <form
              onSubmit={form.onSubmit((values) => {
                const formData = new FormData();
                formData.append("username", values.username);
                formData.append("email", values.email);
                formData.append("password", values.password);
                formData.append("profile_image", values.profile_image);
                formData.append("privileges", values.privileges);

                apiWithInterceptor
                  .post("/user", formData, {
                    headers: {
                      "Content-Type": "multipart/form-data",
                    },
                  })
                  .then(function () {
                    showNotification({
                      title: "Success",
                      message: "User successfully created",
                      color: "green",
                    });
                    setOpenModal(false);
                  })
                  .catch(function (error) {
                    showNotification({
                      title: "Something went wrong",
                      message: `${error?.response?.data?.message}`,
                      color: "red",
                    });
                  });
              })}
            >
              <TextInput
                label="User name"
                placeholder="Enter the user-name"
                {...form.getInputProps("username")}
              />
              <TextInput
                label="Email"
                placeholder="Enter your email"
                {...form.getInputProps("email")}
              />
              <PasswordInput
                label="Password"
                placeholder="Enter your password"
                {...form.getInputProps("password")}
              />

              <FileInput
                placeholder="Select profile image"
                label="Profile image"
                {...form.getInputProps("profile_image")}
              />
              <Select
                label="Privileges"
                placeholder="Select user privileges"
                data={["ADMIN", "USER"]}
                {...form.getInputProps("privileges")}
              />
              <Group sx={{ marginTop: "20px" }}>
                <Button fullWidth type="submit">
                  Create User
                </Button>
                <Button
                  color="red"
                  fullWidth
                  onClick={() => {
                    setOpenModal(false);
                  }}
                >
                  Cancel
                </Button>
              </Group>
            </form>
          </SimpleGrid>
        </Modal>
      </Group>
    </>
  );
};

export default CreateUserModal;
